import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from 'firebase/firestore';
import { firestore } from './firebase';

export interface TeamLimits {
  numTenders?: number;
  numDrafts?: number;
  numReviews?: number;
  numReports?: number;
  numAdHocDocs?: number;
  numSectionChats?: number;
}

export interface Team {
  id: string;
  teamName: string;
  description?: string;
  teamLeadId?: string;
  limits?: TeamLimits;
  clientId: string;
}

export const getTeam = async (teamId: string): Promise<Team | null> => {
  const docRef = doc(firestore, 'teams', teamId);
  const snap = await getDoc(docRef);
  if (snap.exists()) {
    return { id: snap.id, ...snap.data() } as Team;
  }
  return null;
};

export const getTeamsByClient = async (clientId: string): Promise<Team[]> => {
  const q = query(collection(firestore, 'teams'), where('clientId', '==', clientId));
  const snap = await getDocs(q);
  return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }) as Team);
};

export const getTeamByIdQuery = async (teamId: string): Promise<Team[]> => {
  const q = query(collection(firestore, 'teams'), where('__name__', '==', teamId));
  const snap = await getDocs(q);
  return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }) as Team);
};

export const getAllTeams = async (): Promise<Team[]> => {
  const snap = await getDocs(collection(firestore, 'teams'));
  return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }) as Team);
};

export const updateTeam = async (teamId: string, updates: Partial<Team>): Promise<void> => {
  await updateDoc(doc(firestore, 'teams', teamId), updates);
};

export const createTeam = async (teamData: Omit<Team, 'id'>): Promise<string> => {
  const ref = await addDoc(collection(firestore, 'teams'), {
    ...teamData,
    createdAt: serverTimestamp(),
  });
  return ref.id;
};
